<template>
  <div>
    <el-dialog
    append-to-body 
      :visible.sync="addServiceDialog"
      width="50%"
      title="福利日设置"
      :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        label-width="auto"
        :rules="rules"
        ref="benefitForm"
      >
        <el-form-item label="名称" prop="title" required>
          <el-input v-model="form.title" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type" required>
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in benefitTypes"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可用日期" prop="day_type">
          <el-radio-group v-model="form.day_type" @change="changeDays = []">
            <el-radio :label="1">每月</el-radio>
            <el-radio :label="2">每周</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="每周" v-if="form.day_type == 2" required>
          <el-checkbox-group v-model="changeDays">
            <el-checkbox
              :label="w.value"
              v-for="w in weekInfo"
              :key="w.value"
              >{{ w.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="每月" v-if="form.day_type == 1" required>
          <el-select v-model="changeDays" multiple placeholder="请选择">
            <el-option
              v-for="item in dateList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可用时段">
          <el-time-select
            placeholder="起始时间"
            v-model="form.s_time"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '23:00',
            }"
          >
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="form.e_time"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
              minTime: form.s_time,
            }"
          >
          </el-time-select>
        </el-form-item>

        <el-form-item label="福利时间" required>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-DD"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="当天可用次数">
          <el-input
            v-model="form.usage_limit"
            placeholder="预约次数"
          ></el-input>
        </el-form-item>

        <el-form-item label="折扣">
          <el-input
            v-model="form.benefit_ratio"
            placeholder="折扣，免费填0，如6.9折输入0.69"
          ></el-input>
        </el-form-item>
      </el-form>
      <span class="dialog-footer">
        <el-button @click="router.back()">返 回</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修改福利</el-button
        >
        <el-button v-else type="primary" @click="submitForm()"
          >确认新增</el-button
        >
      </span>

      <div class="mt20"></div>

      <el-card header="会员卡可用场地或时间段设置" shadow="never">
        <p v-if="matchList.length == 0">
          默认所有场地，所有时间段都可预约
        </p>
        <el-button type="primary" @click="addMatchitem">添加使用规则</el-button>
        <el-form
          :inline="true"
          v-for="(v, i) in matchList"
          :key="i"
          class="mt20"
        >
          <el-form-item label="">
            <el-radio-group v-model="v.way">
              <el-radio label="area" @click="v.device_id = 0">区域</el-radio>
              <el-radio label="device" @click="v.area_id = 0">场地</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可约场地" v-if="v.way == 'device'">
            <el-select v-model="v.device_id" placeholder="请选择">
              <el-option
                v-for="item in devices"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click.native="setName(item, v)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可约区域" v-else>
            <el-select v-model="v.area_id" placeholder="请选择">
              <el-option
                v-for="item in area_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click.native="setName(item, v)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可约时间段">
            <el-time-select
              placeholder="起始时间"
              v-model="v.s_time"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00',
              }"
            >
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="v.e_time"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '24:00',
                minTime: v.s_time,
              }"
            >
            </el-time-select>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="matchList.splice(i, 1)"
              >删除</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="form.id" type="success" @click="updateMatchs(v)"
          >保存规则</el-button
        >
      </el-card>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      benefitTypes: [
    
    {
      name: "开放日",
      value: 'open',
    },
    {
      name: "会员日",
      value: 'vip',
    }
  ],
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      if_clear: true,
      count: 1,
      cityList: [],
      weekInfo: [
        { name: "周一", value: '1' },
        { name: "周二", value: '2' },
        { name: "周三", value: '3' },
        { name: "周四", value: '4' },
        { name: "周五", value: '5' },
        { name: "周六", value: '6' },
        { name: "周七", value: '0' },
      ],
      dateList: [],
      changeDays: [],
      dateRange: [],
      matchList: [],
      card: {},
      area_list: [],
      devices: [],
      is_init: false,
    };
  },

  computed: {
    categories_child_list() {
      return this.$store.state.categories_child_list;
    },
  },
  mounted() {
    let list = [];
    for (let i = 1; i <= 31; i++) {
      list.push({
        name: i + "号",
        value: i+'',
      });
    }
    this.dateList = list;
  },

  methods: {
    //修改规则
    updateMatchs() {
      if (!this.checkMatchItems()) {
        return;
      }
      this.$post("user/benefitMatch/updates", {
        benefit_id: this.form.id,
        matchs: this.matchList,
      }).then(() => {
          this.addServiceDialog = false;
      });
    },

    setName(row, v) {
      v.name = row.name;
    },
    initDeviceList() {
      let param = {
        status: 0,
        pageSize: 50,
        venue_id: this.card.venue_id,
      };
      this.$get("shared/venueDevice/queryListPage", param).then((res) => {
        this.devices = res.data.data;
      });
    },
    initAreaList() {
      let param = {
        status: 0,
        pageSize: 10,
        venue_id: this.card.venue_id,
      };
      this.$get("shared/venueArea/queryListPage", param).then((res) => {
        this.area_list = res.data.data;
      });
    },
    //添加规则项
    addMatchitem() {
      let p = { way: "area" };
      if (this.matchList.length > 0) {
        let last = this.matchList[this.matchList.length - 1];
        if (!last.e_time) {
          ElMessage("请填写可用时间段");
          return;
        }
      }

      this.matchList.push(p);
    },
    open(info, card) {
      this.card = card;
      if (info && info.id) {
        this.$get('user/benefitDay/findById', {id: info.id}).then(res => { 
            let benefit = res.data.data;
             this.temp = Object.assign({}, benefit);
            this.form = benefit;
            if (benefit.matchs) {
            benefit.matchs.forEach((v) => {
                v.way = v.device_id > 0 ? 'device':'area'
            });
            }
            this.matchList = benefit.matchs;
            this.changeDays = benefit.day_value.split(",");
            this.dateRange = [benefit.start_time.split(' ')[0], benefit.end_time.split(' ')[0]]
            let times = benefit.time_slot.split('-')
            this.form.s_time = times[0]
            this.form.e_time = times[1]
        })
       
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
      if (!this.is_init) {
        this.is_init = true;
        this.initDeviceList();
        this.initAreaList();
      }
    },
    updateForm() {
         if (this.changeDays.length == 0) {
        this.$message("请选择日期");
        return;
      }
      if (this.dateRange.length == 0) {
        this.$message("请选择日期");
        return;
      }
      if (!this.form.s_time || !this.form.e_time) {
        this.$message("请选择时间段");
        return;
      }
      this.$refs.benefitForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      if (this.changeDays.length == 0) {
        this.$message("请选择日期");
        return;
      }
      if (this.dateRange.length == 0) {
        this.$message("请选择日期");
        return;
      }
      if (!this.form.s_time || !this.form.e_time) {
        this.$message("请选择时间段");
        return;
      }

      this.$refs.benefitForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/benefitDay/insert";

      this.form.day_value = this.changeDays.join(",");
      this.form.start_time = this.dateRange[0] + " 00:00:00";
      this.form.end_time = this.dateRange[1] + " 23:59:59";
      this.form.time_slot = `${this.form.s_time}-${this.form.e_time}`;
      this.form.mechanism_id = this.card.mechanism_id;
      this.form.venue_id = this.card.venue_id;
      this.form.card_id = this.card.id
      if (this.matchList.length > 0) {
        this.form.matchs = this.matchList;
      }

      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
         this.form.day_value = this.changeDays.join(",");
      this.form.start_time = this.dateRange[0] + " 00:00:00";
      this.form.end_time = this.dateRange[1] + " 23:59:59";
      this.form.time_slot = `${this.form.s_time}-${this.form.e_time}`;
    
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      this.if_clear = false;
      let url = "/user/benefitDay/update";
      this.form.deduction_course_num = 1;
      this.$axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message({ type: "success", message: "修改成功!" });
          this.addServiceDialog = false;
          this.if_clear = true;
          this.form = {};
          this.temp = {};
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: res.message });
        }
      });
    },
    //检查预约规则是否都填写写
    checkMatchItems() {
      for (let i = 0; i < this.matchList.length; i++) {
        let item = this.matchList[i];
        if (!item.e_time) {
          ElMessage("请选择时间");
          return false;
        }
        item.e_time = item.e_time == "00:00" ? "24:00" : item.e_time;
      }

      return true;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>